import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap'

import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'
import RegisterForm from '../../Forms/RegisterForm/RegisterForm.jsx'
import SubmitButton from '../../Forms/RegisterForm/SubmitButton.jsx'

export default class RegisterInvitationModal extends Modal {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      error: false
    }

    this.close = () => this.props.closeModal()
  }

  onSubmitSuccess = () => {
    this.close()
  }

  render() {
    const modalProps = {}

    if (!this.state.loading) {
      modalProps.toggle = this.close
    }

    return (
      <BootstrapModal {...modalProps} isOpen={this.props.isOpen}>
        <ModalHeader {...modalProps}>Inscription</ModalHeader>
        {this.state.loading ?
          <ModalBody>
            <Loader fill={false} visible={true}/>
          </ModalBody>
          :
          this.state.error ?
            <ModalBody>
              Aïe Aïe Aïe
            </ModalBody>
            :
            <ModalBody>
              <RegisterForm
                initialValues={{
                  token: this.props.token,
                }}
                noData={true}
                onSubmitSuccess={this.onSubmitSuccess}
              />
              <SubmitButton className="btn btn-primary my-3">S'enregistrer</SubmitButton>
            </ModalBody>
        }

      </BootstrapModal>
    )
  }
}
